import {
  CHANGE_PASSWORD,
  EDIT_PROFILE,
  EDIT_PROFILE_API,
  FORGOT_PASSWORD,
  LOGIN,
  VERIFY_EMAIL,
  VIEW_PROFILE,
} from "./ApiRoutes";
import { authData } from "./services";

export const login = async (data: object) => {
  const response = await authData.post(LOGIN, data);
  return response?.data;
};

export const verifyEmail = async (data: object) => {
  const response = await authData.post(VERIFY_EMAIL, data);
  return response?.data;
};

export const forgotPassword = async (data: object) => {
  const response = await authData.post(FORGOT_PASSWORD, data);
  return response?.data;
};

export const changePassword = async (data: object) => {
  const response = await authData.put(CHANGE_PASSWORD, data);
  return response?.data;
};

export const viewProfile = async () => {
  const response = await authData.get(VIEW_PROFILE);
  return response?.data;
};

export const editProfile = async (data: object) => {
  const response = await authData.put(EDIT_PROFILE_API, data);
  return response?.data;
};
